import Paper from '@/components/Paper'
import {
    Service,
    ServiceConfigoption,
    ServiceConfigoptionName,
} from '@/modules/Service/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'
import { useForm } from 'react-hook-form'
import MainServiceColocation from './MainServiceColocation'
import AddonServiceColocation from './AddonServiceColocation'

interface RackUnitProps {
    service: Service
    data: {
        configoptions: ServiceConfigoption[]
        addons: (Service & {
            configoptions: ServiceConfigoption[]
        })[]
    }
}

const RackUnit: React.FC<RackUnitProps> = ({ data }) => {
    const { t } = useTranslation()

    // Get ColocationU config from main service
    const colocationUConfig = data?.configoptions?.find(
        (config) =>
            config.name === ServiceConfigoptionName.U ||
            config.name === ServiceConfigoptionName.ColocationU
    )

    // Get all addon services that have ColocationU
    const addonsWithColocationU = data?.addons?.filter((addon) =>
        addon.configoptions?.some(
            (config) =>
                config.name === ServiceConfigoptionName.U ||
                config.name === ServiceConfigoptionName.ColocationU
        )
    )

    const formControl = useForm<any>({
        defaultValues: {
            service: colocationUConfig,
            addons: data?.addons?.map((addon) => ({
                ...addon,
                configoptions: addon?.configoptions?.find(
                    (config) =>
                        config.name === ServiceConfigoptionName.U ||
                        config.name === ServiceConfigoptionName.ColocationU
                ),
            })),
        },
    })

    // Don't render if no ColocationU config found
    if (!colocationUConfig) return null

    return (
        <Paper className="mt-2 p-4 border rounded-[4px]">
            {/* Header */}
            <div className="flex items-center justify-between mb-3">
                <Typogaphy className="text-sm font-medium text-foreground">
                    {t('provider-colocation-information')}
                </Typogaphy>
            </div>

            <div className="space-y-3">
                {/* Main Service */}
                <MainServiceColocation formControl={formControl} />

                {/* Addons */}
                {addonsWithColocationU && addonsWithColocationU.length > 0 && (
                    <div className="space-y-3">
                        <Typogaphy className="text-sm font-medium text-foreground mt-4">
                            {t('Addons with Colocation U')}
                        </Typogaphy>
                        {addonsWithColocationU.map((addon) => {
                            const addonConfig = addon?.configoptions?.find(
                                (c) =>
                                    c.name === ServiceConfigoptionName.U ||
                                    c.name ===
                                        ServiceConfigoptionName.ColocationU
                            )
                            if (!addonConfig) return null

                            return (
                                <AddonServiceColocation
                                    key={addon.service_id}
                                    addon={addon}
                                    configoption={addonConfig}
                                />
                            )
                        })}
                    </div>
                )}
            </div>
        </Paper>
    )
}

export default RackUnit
